<template>
  <div class="position--relative">
    <horizontal-type-c class="header-horizontal-type-c border spacing--md">
    </horizontal-type-c>
    <slot></slot>
    <footer-type-a></footer-type-a>
  </div>
</template>

<script>
export default {
  components: {
    HorizontalTypeC: () => import('@/component/layout/header/horizontal/TypeABC'),
    FooterTypeA: () => import('@/component/layout/footer/TypeA')
  }
}
</script>
